export const hasSelectedFiles = (selectedFile: File[] | undefined): selectedFile is File[] =>
  Array.isArray(selectedFile) && selectedFile.length > 0;
